import { CSSProperties, FC } from 'react';

interface Props {
  colour: string;
  withoutShadow?: boolean;
  size?: number;
  styles?: CSSProperties;
}

const Dot: FC<Props> = ({ colour, withoutShadow, size = 8, styles }) => (
  <div
    style={{
      width: size,
      height: size,
      borderRadius: '50%',
      backgroundColor: colour,
      boxShadow: withoutShadow ? 'none' : `0px 0px 8px ${colour}`,
      ...styles,
    }}
  />
);

export const SpanDot: FC<Props> = ({ colour, withoutShadow, size = 8, styles }) => (
  <span
    style={{
      width: size,
      height: size,
      marginRight: 5,
      borderRadius: '50%',
      backgroundColor: colour,
      boxShadow: withoutShadow ? 'none' : `0px 0px 8px ${colour}`,
      display: 'inline-block',
      ...styles,
    }}
  />
);

export default Dot;
